export default __webpack_public_path__ + "static/media/smart-folder-medium-parent.baeee2b6.svg";